import * as React from 'react';
import {View} from 'react-native';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {images} from '../../../../assets/icons';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {useStyles} from '../../../../shared/hooks/styles';
import {Props} from './model';
import {Text} from '../../../../shared/components/text';

export default ({text}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      backgroundColor: theme.privilegeSsmResult.backgroundColor,
      borderRadius: 2,
      shadowOpacity: 0.1,
      shadowOffset: {width: 0, height: 2},
      shadowRadius: 18,
      shadowColor: theme.color.primaryBlackColor,
      width: '100%',
      overflow: 'hidden',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          height: 78,
          paddingLeft: 44,
          paddingRight: 44,
          paddingTop: 19,
          paddingBottom: 19,
        },
        {
          minHeight: 90,
          paddingLeft: 21,
          paddingRight: 35,
          paddingTop: 19,
          paddingBottom: 19,
        },
      ),
    },
    text: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h4, theme.fonts.action),
      color: theme.privilegeSsmResult.color,
      textAlign: 'center',
    },
    textWrapper: {
      flexGrow: 0,
      flexShrink: 1,
      width: '100%',
      ...mediaOnly(DeviceSize.desktop, {}, {paddingTop: 6, paddingBottom: 6}),
    },
    content: {
      flexDirection: 'row',
      color: theme.privilegeSsmResult.color,
      flex: 1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          alignItems: 'center',
        },
        {
          alignItems: 'flex-start',
        },
      ),
    },
    icon: {
      color: theme.privilegeSsmResult.color,
      ...mediaOnly(
        DeviceSize.desktop,
        {width: 40, height: 40, marginRight: 25},
        {width: 30, height: 30, marginRight: 15},
      ),
    },
    image: {
      position: 'absolute',
      zIndex: -1,
      right: 0,
      top: 0,
    },
  }));
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* <ResponsiveView only={[DeviceSize.desktop]}>
          <View style={styles.icon}>
            <images.Check width={40} height={40} color={styles.icon.color as string} />
          </View>
        </ResponsiveView> */}
        {/* <ResponsiveView exclude={[DeviceSize.desktop]}>
            <images.Check width={30} height={30} color={styles.icon.color as string} />
          </ResponsiveView> */}
        <View style={styles.textWrapper}>
          <Text style={styles.text}>{text}</Text>
        </View>
      </View>
      <View style={styles.image}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <images.PrivilegeSuccessPattern width={390} height={78} hideForVisuallyImpaired />
        </ResponsiveView>
        <ResponsiveView exclude={[DeviceSize.desktop]}>
          <images.PrivilegeSuccessPatternMobile width={290} height={90} hideForVisuallyImpaired />
        </ResponsiveView>
      </View>
    </View>
  );
};
